<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app" style="overflow: auto">
			<reporting-sidenav></reporting-sidenav>
			<div id="content" class="app-content box-shadow-3 d-flex flex w-100">
				<div class="d-flex flex-column flex" style="overflow: auto">
					<!-- Optional navbar at top of page -->
					<div class="navbar navbar-expand-lg flex-nowrap box-shadow">
						<!-- Page title -->
						<div class="navbar-text nav-title flex" id="pageTitle">
							Auditing
							<span class="far fa-fw fa-angle-right"></span>Responses
						</div>
						<div
							class="btn-topnav b-l ml-0 d-flex flex-column justify-content-center"
							@click="attemptExport()"
							v-tippy="{ placement: 'bottom' }"
							title="Export Scores"
						>
							<i class="fas fa-lg fa-download"></i>
						</div>

						<!-- Multiselect actions -->
						<div class="btn-group" v-if="numSelected > 0">
							<div class="navbar-text nav-title no-grow mr-2" id="pageTitle">
								{{ numSelected }} Selected
							</div>
							<button class="btn white" data-toggle="dropdown" aria-expanded="false">
								<i class="fas fa-ellipsis-v faw"></i>
							</button>
							<div class="dropdown-menu dropdown-menu-right">
								<a
									v-if="user.role.delete_data"
									class="dropdown-item"
									data-toggle="modal"
									data-target="#deleteResponses"
								>
									<i class="far fa-trash faw"></i>
									<label class="mb-0">Delete</label>
								</a>
								<a
									v-if="user.role.delete_data"
									class="dropdown-item"
									data-toggle="modal"
									data-target="#resetResponses"
								>
									<i class="far fa-strikethrough faw"></i>
									<label class="mb-0">Clear Scores</label>
								</a>
								<a
									v-if="reliabilityItem"
									class="dropdown-item"
									data-toggle="modal"
									data-target="#confirmReliability"
								>
									<i class="far fa-check-double faw"></i>
									<label class="mb-0">Mark for Reliability</label>
								</a>
							</div>
						</div>
					</div>

					<!-- Page Content -->
					<div
						class="d-flex flex flex-row h100 mb-auto align-items-stretch"
						style="background-color: white; overflow: auto"
					>
						<div class="aside d-flex scroll-y">
							<div class="modal-dialog w-md light b-r b-t white p-2 audit-search">
								<div class="form-group" v-if="teams && teams.length > 0">
									<label>Collaborative Scoring Team</label>
									<config-select
										:options="teams"
										v-model="selectedTeam"
										:nullOption="true"
									></config-select>
								</div>
								<div class="form-group">
									<label>Teacher</label>
									<config-user-search v-model="teacher" />
								</div>
								<div class="form-group" v-if="teacher && teacherClasses && teacherClasses.length > 0">
									<label>Class</label>
									<config-select
										:nullOption="true"
										nullText="Any"
										:options="teacherClasses"
										v-model="selectedClass"
									></config-select>
								</div>
								<div
									class="form-group invalid"
									v-if="teacher && teacherClasses && teacherClasses.length == 0"
								>
									<label>Class</label>
									<config-select :options="teacherClasses" v-model="selectedClass"></config-select>
								</div>
								<div class="form-group" v-if="!selectedClass">
									<label>Content Area</label>
									<config-select
										:nullOption="true"
										nullText="Any"
										:options="contentAreas"
										v-model="selectedCA"
									></config-select>
								</div>
								<div class="form-group" v-if="!selectedClass">
									<label>Grade</label>
									<config-select
										:nullOption="true"
										nullText="Any"
										sortBy="sequence"
										:options="grades"
										v-model="selectedGrade"
									></config-select>
								</div>
								<div class="form-group" :class="{ invalid: !loading && !selectedAsmt }">
									<label>Assessment</label>
									<config-select
										:options="filteredAssessments"
										v-model="selectedAsmt"
									></config-select>
								</div>
								<div class="form-group">
									<label>State</label>
									<v-select :options="states" :searchable="false" v-model="selectedState"></v-select>
								</div>
								<div class="form-group">
									<label>Student</label>
									<config-student-search v-model="student" />
								</div>
								<div class="form-group">
									<label>Scored By</label>
									<config-user-search v-model="users" includeTeams multiple />
								</div>
								<div class="form-group">
									<label>Has Score Type</label>
									<v-select multiple :options="score_types" v-model="filter_types"></v-select>
								</div>

								<div class="btn-group mt-2 btn-block w-100">
									<button @click="showQueryModal()" class="btn btn-block theme">Query Scores</button>
									<button
										@click="clearScoreSearch()"
										class="btn theme lighten-2"
										v-tippy
										title="Clear"
									>
										<i class="far fa-times"></i>
									</button>
								</div>
								<table class="table condensed-table" v-if="ats_display && ats_display.length > 0">
									<tr>
										<th>Type</th>
										<th>Trait</th>
										<th>Score</th>
									</tr>
									<tr v-for="(row, i) in ats_display" :key="i">
										<td v-if="row.first_of_type" :rowspan="row.rowspan" class="v-mid">
											<span v-if="row.score_type == 0">Any</span>
											<span class="d-flex flex-row align-items-center" v-if="row.score_type != 0">
												<i class="material-icons mi-small mr-1">{{
													fs.scoreTypeIcon(row.score_type)
												}}</i>
												{{ fs.scoreTypeAbr(row.score_type) }}
											</span>
										</td>
										<td>{{ row.name }}</td>
										<td>{{ row.score }}</td>
									</tr>
								</table>

								<div class="d-flex flex-row align-items-center mt-2">
									<label class="ui-switch ui-switch-md theme-accent">
										<input type="checkbox" v-model="archived" />
										<i></i>
									</label>
									<div class="_600 ml-2">Archived</div>
								</div>
							</div>
						</div>
						<div class="flex d-flex flex-column" style="overflow: hidden">
							<div class="flex scroll-y scroll-x">
								<!-- Page content goes here -->
								<b-table
									ref="table"
									striped
									hover
									:show-empty="true"
									:items="provider"
									:fields="fields"
									:current-page="currentPage"
									:per-page="perPage"
									:filter="filter"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
								>
									<!-- Select -->
									<template slot="HEAD_select" slot-scope="data">
										<table-multiselect
											v-model="selectedIDs"
											:selectAll.sync="selectAll"
											master
											:items="currentItems"
											byField="id"
											:totalRows="totalRows"
											:numSelected.sync="numSelected"
											:query="query"
											:reset="resetSelection"
										></table-multiselect>
									</template>
									<template slot="select" slot-scope="data">
										<table-multiselect
											:value="selectedIDs"
											:selectAll="selectAll"
											:id="data.item.id"
										></table-multiselect>
									</template>

									<!-- Student -->
									<template slot="student_ln" slot-scope="data">
										<div
											v-tippy="{ theme: 'popover', placement: 'bottom' }"
											:title="auditDetailsTooltip(data.item)"
										>
											<div v-if="data.item.reliability_score" class="dot"></div>
											<div v-if="!data.item.reliability_score" class="nodot"></div>

											<span v-if="data.item.student_ln && data.item.student_fn"
												>{{ data.item.student_ln }}, {{ data.item.student_fn }}</span
											>
											<span v-if="data.item.student_ln && !data.item.student_fn">{{
												data.item.student_ln
											}}</span>
											<span v-if="!data.item.student_ln && data.item.student_fn">{{
												data.item.student_fn
											}}</span>
											<span
												v-if="!data.item.student_ln && !data.item.student_fn"
												class="text-muted"
												>(Missing)</span
											>

											<span
												v-if="data.item.student_ln || data.item.student_fn"
												class="text-xxs text-muted"
												>({{ data.item.student_ref_id }})</span
											>
										</div>
									</template>

									<!-- CST -->
									<template slot="cst" slot-scope="data">
										<i
											v-if="data.item.team_id && getTeam(data.item.team_id)"
											class="fas fa-hands-helping"
											v-tippy
											:title="cstTooltip(getTeam(data.item.team_id).name)"
										/>
										<div
											v-if="!(data.item.team_id && getTeam(data.item.team_id))"
											class="text-extra-muted"
										>
											None
										</div>
									</template>

									<!-- Exported At -->
									<template slot="priority" slot-scope="data">
										<span v-if="data.item.priority > 0">+{{ data.item.priority }}</span>
										<span v-if="data.item.priority == 0" class="text-muted"></span>
									</template>

									<!-- State -->
									<template slot="state" slot-scope="data">
										{{ getState(data.item.state) }}
										<i
											v-if="
												reliabilityItem && data.item.state == 1 && data.item.reliability_score
											"
											class="far fa-check-double text-muted ml-1"
											v-tippy
											title="Will go to Reliability"
										></i>
										<i
											v-if="
												data.item.flags &&
												data.item.flags.length > 0 &&
												!allFlagsReviewed(data.item)
											"
											class="far fa-flag text-muted ml-1"
											:id="`flags-${data.item.id}`"
											v-b-popover
										></i>
										<i
											v-if="
												data.item.flags &&
												data.item.flags.length > 0 &&
												allFlagsReviewed(data.item)
											"
											class="fas fa-flag text-muted ml-1"
											:id="`flags-${data.item.id}`"
											v-b-popover
										></i>
										<b-popover
											v-if="data.item.flags && data.item.flags.length > 0"
											:target="`flags-${data.item.id}`"
											triggers="hover"
										>
											<template slot="title">Flags:</template>
											<div v-for="(flag, i) in data.item.flags" :key="i">
												<i v-if="flag.reviewed" class="far fa-fw fa-eye"></i>
												<i v-if="!flag.reviewed" class="far fa-fw fa-eye-slash"></i>
												{{ getFlagName(flag) }}
											</div>
										</b-popover>
									</template>

									<!-- Scores -->
									<template slot="scores" slot-scope="data">
										<span class="d-flex flex-row">
											<span
												v-if="data.item.scores.length"
												v-for="score in data.item.scores"
												:key="score.id"
											>
												<span
													v-tippy="{
														theme: 'popover',
														html: `#s-${score.id}`,
														placement: 'top-start',
													}"
													class="badge theme mr-1 pointer"
												>
													<i class="material-icons score-badge">{{
														fs.scoreTypeIcon(score.score_type)
													}}</i>
												</span>
												<div class="d-none p-0" :id="`s-${score.id}`">
													<Score :score="score" :rubric="selectedItem.rubric"></Score>
												</div>
											</span>
										</span>
									</template>

									<!-- Created At -->
									<template slot="created_at" slot-scope="data">{{
										format(data.item.created_at)
									}}</template>
									<!-- Exported At -->
									<template slot="exported_at" slot-scope="data">
										<span v-if="data.item.exported">{{ format(data.item.exported_at) }}</span>
										<span v-if="!data.item.exported" class="text-muted"></span>
									</template>
									<!-- Edit -->
									<template slot="actions" slot-scope="data">
										<div v-if="!resultArchived" class="d-flex flex-rows">
											<div class="w30">
												<a
													:href="`#/audit/${selectedAsmt.id}/${selectedItem.id}/${data.item.id}`"
													class="btn btn-sm btn-icon btn-rounded theme-accent text-white m-0"
													v-tippy
													title="View"
												>
													<i class="far fa-search"></i>
												</a>
											</div>
											<div v-if="canScore(data.item)" class="w30">
												<a
													@click="score(data.item)"
													class="btn btn-sm btn-icon btn-rounded theme text-white m-0"
													v-tippy
													title="Score"
												>
													<i v-if="data.item.state <= 2" class="material-icons tiny">check</i>
													<i
														v-if="data.item.state > 2 && data.item.state != 10"
														class="material-icons tiny"
														>done_all</i
													>
												</a>
											</div>
											<div v-if="data.item.locked" class="w30">
												<a
													@click="unlock(data.item)"
													class="btn btn-sm btn-icon btn-rounded theme text-white m-0"
													v-tippy
													title="Unlock"
												>
													<i class="far fa-unlock"></i>
												</a>
											</div>
										</div>
									</template>
								</b-table>
							</div>
							<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
								<a class="flex mx-3"
									>Page {{ totalRows > 0 ? currentPage : 0 }} of
									{{ Math.ceil(totalRows / perPage) }} ({{ totalRows }})</a
								>
								<div>
									<b-pagination
										size="md"
										class="m-1"
										:total-rows="totalRows"
										v-model="currentPage"
										:per-page="perPage"
									></b-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- TraitScore query modal -->
		<b-modal
			id="traitScoreModal"
			size="lg"
			v-model="queryModal"
			v-if="selectedItem && selectedItem.rubric"
			no-fade
			@hide="hideQueryModal"
		>
			<template slot="modal-title">Score Query</template>
			<div class="row">
				<table class="table ats-table">
					<thead v-if="score_specific_query">
						<tr>
							<th style="width: 50%"></th>
							<th></th>
							<th>
								<span class="d-flex flex-row align-items-center justify-content-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(1) }}</i>
									{{ fs.scoreTypeAbr(1) }}
								</span>
							</th>
							<th>
								<span class="d-flex flex-row align-items-center justify-content-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(2) }}</i>
									{{ fs.scoreTypeAbr(2) }}
								</span>
							</th>
							<th>
								<span class="d-flex flex-row align-items-center justify-content-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(3) }}</i>
									{{ fs.scoreTypeAbr(3) }}
								</span>
							</th>
							<th>
								<span class="d-flex flex-row align-items-center justify-content-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(4) }}</i>
									{{ fs.scoreTypeAbr(4) }}
								</span>
							</th>
							<th style="width: 50%"></th>
						</tr>
					</thead>
					<thead v-if="!score_specific_query">
						<tr>
							<th style="width: 50%"></th>
							<th></th>
							<th class="text-center">Score</th>
							<th style="width: 50%"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="trait in selectedItem.rubric.traits" :key="trait.id">
							<td></td>
							<td class="p-custom pr-4 v-mid">{{ trait.name }}</td>
							<td v-if="!score_specific_query" style="width: 10px">
								<v-select
									:onChange="tsChange(trait.id, 0)"
									class="v-select-narrow"
									:options="traitSelectionMap[trait.id][0].sps"
									:value="traitSelectionMap[trait.id][0].selected"
									:searchable="false"
									:clearable="false"
								></v-select>
							</td>
							<td v-if="score_specific_query" v-for="st in score_types" :key="st.type">
								<v-select
									:onChange="tsChange(trait.id, st.type)"
									class="v-select-narrow"
									:options="traitSelectionMap[trait.id][st.type].sps"
									:searchable="false"
									:clearable="false"
									:value="traitSelectionMap[trait.id][st.type].selected"
								></v-select>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
			<template slot="modal-footer">
				<div class="d-flex flex-row align-items-center">
					<div class="_600 mr-2">By Score</div>
					<label class="ui-switch ui-switch-md theme-accent mr-3">
						<input type="checkbox" v-model="score_specific_query" />
						<i></i>
					</label>
					<button @click="applyQueryModal" class="btn btn-flat primary">Apply</button>
				</div>
			</template>
		</b-modal>

		<div class="modal" id="alreadyScoredWarning" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Warning!</h5>
					</div>
					<div class="modal-body text-center">
						<span class="text-md" v-if="selected_resp">
							You have already scored response
							<strong>{{ selected_resp.ref_id }}</strong>
						</span>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Cancel</button>
						<button @click="scoreResponse(selected_resp)" class="btn btn-flat theme" data-dismiss="modal">
							Score
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="confirmExport" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Export to API</h5>
					</div>
					<div class="modal-body">
						<h6>
							Export {{ numSelected }} {{ numSelected == 1 ? "response" : "responses" }} to external API?
						</h6>
						<div>
							<div class="form-group" v-if="selectedItem && selectedItem.api_export_config">
								<input class="form-control" readonly v-model="selectedItem.api_export_config.url" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Cancel</button>
						<button @click="queueExport()" class="btn btn-flat theme" data-dismiss="modal">Deliver</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="confirmReliability" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Mark for Reliability</h5>
					</div>
					<div class="modal-body">
						<h6>
							Mark {{ numSelected }} {{ numSelected == 1 ? "response" : "responses" }} responses to
							require a second read?
						</h6>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Cancel</button>
						<button @click="markReliability()" class="btn btn-flat theme" data-dismiss="modal">OK</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="setPriority" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Set Priority</h5>
					</div>
					<div class="modal-body">
						<h6>Set priority on {{ numSelected }} {{ numSelected == 1 ? "response" : "responses" }}:</h6>
						<div>
							<div class="form-group">
								<input class="form-control" type="number" v-model.number="pickPriority" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Cancel</button>
						<button @click="setPriority(pickPriority)" class="btn btn-flat theme" data-dismiss="modal">
							Set Priority
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="deleteResponses" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Delete Responses</h5>
					</div>
					<div class="modal-body">
						<h6 class="mb-4">
							Do you really want to delete {{ numSelected }}
							{{ numSelected == 1 ? "response" : "responses" }}?
						</h6>
						<h6>
							<span class="text-danger far faw fa-exclamation-triangle"></span>
							The operation will occur immediately, cannot be canceled or reversed, and will remove
							information from reports and exports!
						</h6>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Cancel</button>
						<button @click="deleteResponses()" class="btn btn-flat btn-danger" data-dismiss="modal">
							Delete
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="resetResponses" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Reset Responses</h5>
					</div>
					<div class="modal-body">
						<h6 class="mb-4">
							Do you really want to reset all score data on {{ numSelected }}
							{{ numSelected == 1 ? "response" : "responses" }}?
						</h6>
						<h6>
							<span class="text-danger far faw fa-exclamation-triangle"></span>
							The operation will occur immediately, cannot be canceled or reversed, and will remove
							information from reports and exports!
						</h6>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal">Cancel</button>
						<button @click="resetResponses()" class="btn btn-flat btn-danger" data-dismiss="modal">
							Reset
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Export -->
		<b-modal
			id="exportModal"
			:visible="exportingItem != false"
			v-if="exportingItem"
			@hidden="exportingItem = false"
		>
			<template slot="modal-title">Export Scores</template>
			<div class="row p-4">
				<div class="col-12 form-group">
					<h5>Export scores from {{ exportingItem.name }}</h5>
				</div>
				<div class="col-12 form-group">
					<label>Export Type</label>
					<v-select :options="exportOptions" v-model="exportType"></v-select>
				</div>
				<div class="col-12">
					<ul style="list-style-type: circle">
						<li style="list-style-type: circle">
							<strong>Response per row:</strong> Each response will have a row in the file with additional
							scores in additional columns
						</li>
						<li style="list-style-type: circle">
							<strong>Score per row:</strong> Each response will have multiple rows, one for each score
						</li>
					</ul>
				</div>
			</div>
			<template slot="modal-footer">
				<button class="btn primary btn-flat" @click="stopExport">Cancel</button>
				<button
					class="btn btn-flat"
					@click="exportScores(selectedAsmt, exportingItem, exportType)"
					:disabled="!exportType"
					:class="{ success: exportType }"
				>
					Export
				</button>
			</template>
		</b-modal>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w40 {
	width: 40px;
}
.w30 {
	width: 30px;
}
.audit-search > .form-group {
	margin-bottom: 5px;
}
.score-badge {
	font-size: 1rem;
	line-height: 1.5rem;
}
.badge {
	width: 1.25rem;
	height: 1.5rem;
	padding: 0 0;
}
.empty-badge {
	box-shadow: inset 0px 0px 0px 2px rgba(0, 0, 0, 0.25);
}
.mi-small {
	font-size: 1rem;
}
.ats-table {
	white-space: nowrap;
}
label {
	margin-top: 0.25rem;
	margin-bottom: 0.25rem;
}
.dot {
	height: 5px;
	width: 5px;
	background-color: #bbb;
	border-radius: 50%;
	display: inline-block;
}
.nodot {
	height: 5px;
	width: 5px;
	border-radius: 50%;
	display: inline-block;
}
.invalid {
	color: red;
}
.invalid > div {
	border: 1px solid red;
}
.btn-topnav {
	margin-top: -8px;
	margin-bottom: -8px;
	width: 56px;
	height: 56px;
	text-align: center;
	cursor: pointer;
}
.btn-topnav:last-child {
	margin-right: -16px;
	margin-left: -16px;
}
.btn-topnav:hover {
	background-color: rgba(0, 0, 0, 0.075);
}
.btn-topnav a {
	line-height: 56px;
}
</style>

<script>
//UI Components
//Libraries
//import _ from "lodash";
import moment from "moment";
import $ from "jquery";

//Services
import AuthService from "@/services/AuthService";
import ConfigService from "@/services/ConfigService";
import AuditingService from "@/services/AuditingService";
import ScoringService from "@/services/ScoringService";
import ClassService from "@/services/ClassService";
import fs from "@/services/FormatService";
import Notie from "@/services/NotieService";
import store from "@/services/Store";
import BB from "bluebird";

import TableMultiselect from "@/components/TableMultiselect";
import ConfigUserSearch from "@/components/ConfigUserSearch";
import ConfigStudentSearch from "@/components/ConfigStudentSearch";
import ConfigSelect from "@/components/ConfigSelect";
import Score from "@/components/Score";

export default {
	name: "Auditing",
	components: {
		Score,
		TableMultiselect,
		ConfigUserSearch,
		ConfigStudentSearch,
		ConfigSelect,
	},
	data() {
		var states = [
			{ label: "　", value: 0 }, //Any
			{ label: fs.responseState(1), value: 1 }, //Unscored
			{ label: fs.responseState(2), value: 2 }, //Reliability
			{ label: fs.responseState(3), value: 3 }, //Resolution
			{ label: fs.responseState(10), value: 10 }, //Complete
		];

		var exportStates = [
			{ label: "　", value: null },
			{ label: "Yes", value: true },
			{ label: "No", value: false },
		];

		var scoreTypes = [
			{ label: fs.scoreTypeAbr(1), type: 1 },
			{ label: fs.scoreTypeAbr(2), type: 2 },
			{ label: fs.scoreTypeAbr(3), type: 3 },
		];

		var state = store.resolveSelectedRespState(this, states, "audit.r.selectedState");
		var exportState = store.resolveFromList(this, exportStates, "value", 0, "audit.r.exportState");

		var filter_types = store.resolveSelectedScoreTypes(this, scoreTypes, "audit.r.filter_types");
		var response_id = store.get(this, "audit.r.response_id");
		var users = store.getDefault(this, "audit.r.users", []);
		var teacher = store.getDefault(this, "audit.r.teacher", null);
		var selectedClass = store.getDefault(this, "audit.r.selectedClass", null);
		var student = store.getDefault(this, "audit.r.student", null);
		var score_specific_query = store.get(this, "audit.r.score_specific_query");
		var sortBy = store.get(this, "audit.r.sortBy");
		var sortDesc = store.get(this, "audit.r.sortDesc");
		var currentPage = store.get(this, "audit.r.currentPage");
		var archived = store.get(this, "audit.r.archived");

		// debugger;

		//Dynamically bound fields
		return {
			fs: fs,
			user: this.$route.meta.user,
			loading: true,
			currentPage: currentPage,
			perPage: 20,
			totalRows: 0,
			filter: "",
			sortBy: sortBy,
			sortDesc: sortDesc,
			currentItems: [],
			query: null,
			selectedIDs: [],
			selectAll: null,
			numSelected: 0,
			queueResetSelection: false,

			teams: [],
			selectedTeam: null,

			teacherClasses: null,
			selectedClass: null,

			contentAreas: [],
			selectedCA: null,

			grades: [],
			selectedGrade: null,

			assessments: [],
			selectedAsmt: null,
			selectedItem: null,

			states: states,
			selectedState: state ? state : states[0],

			response_id: response_id ? response_id : "",
			users: users,
			teacher: teacher,
			student: student,
			archived: archived,
			resultArchived: archived,

			selected_resp: null,

			//Score Query
			score_types: scoreTypes,
			filter_types: filter_types,
			score_specific_query: score_specific_query,
			traitSelectionMap: null,
			audit_trait_scores: [],
			ats_display: null,

			//Labeling
			pickLabels: [],
			//Priority
			pickPriority: 0,

			//Moving section/item
			moveToSection: null,
			moveToItems: [],
			moveToItem: null,

			applyATS: null,
			oldScoreQuery: null,
			queryModal: false,

			exportingItem: false,
			exportOptions: [
				{ label: "Response per row", id: 1 },
				{ label: "Score per row", id: 2 },
			],
			exportType: null,
		};
	},

	created() {
		this.loadConfigData();
		this.refreshTable = _.debounce(() => {
			this.$refs.table.refresh();
		}, 500);
		this.loadTeacherClasses();
	},

	computed: {
		reliabilityItem() {
			return (
				this.selectedItem && this.selectedItem.type != "SINGLE" && this.selectedItem.allow_manual_reliability
			);
		},

		filteredAssessments() {
			if (this.selectedClass) {
				//Filter by class
				return _.filter(this.assessments, (asmt) => {
					let inClass = false;
					_.each(this.selectedClass.deliveries, (del) => {
						if (del.assessment_id == asmt.id) {
							inClass = true;
						}
					});
					return inClass;
				});
			} else if (this.selectedCA && this.selectedGrade) {
				//Filter by CA && grade
				return _.filter(this.assessments, (asmt) => {
					let matchedCA = true;
					if (this.selectedCA) {
						let secondCA = false
						if(asmt.secondary_content_area_id){
							secondCA = asmt.secondary_content_area_id.includes(this.selectedCA.id);
						}
						matchedCA = this.selectedCA.id == asmt.content_area_id || secondCA;
						console.log("checking ...")
					}
					let matchedGrade = true;
					if (this.selectedGrade) {
						matchedGrade = false;
						_.each(asmt.grade_ids, (gid) => {
							if (this.selectedGrade.id == gid) {
								matchedGrade = true;
							}
						});
					}

					return matchedCA && matchedGrade;
				});
			} else {
				//No filter
				return this.assessments;
			}
		},

		fields() {
			let fields = [];
			if (this.user.role.delete_data) {
				fields = fields.concat([
					{
						key: "select",
						thClass: "p-custom p-0 v-mid",
						thStyle: "width: 40px;",
						tdClass: "p-custom p-0 v-mid",
					},
				]);
			}
			fields = fields.concat([{ key: "student_ln", label: "Student", sortable: true }]);
			if (this.teams && this.teams.length > 0) {
				fields = fields.concat([
					{
						key: "cst",
						label: "CST",
						thClass: "text-center",
						tdClass: "text-center",
					},
				]);
			}
			fields = fields.concat([
				{ key: "state", sortable: true },
				{
					key: "scores",
					tdClass: "p-custom p-0 v-mid",
					sortable: false,
				},
				// { key: "has_backread", sortable: true },
				// { key: "has_resolution", sortable: true },
				{ key: "created_at", tdClass: "text-truncate", sortable: true },
				{ key: "actions", tdClass: "p-custom p-0 v-mid" },
			]);

			return fields;
		},
	},

	watch: {
		teacher() {
			this.loadTeacherClasses();
			store.set(this, "audit.r.teacher", this.teacher);
			if (!(this.teacher && !this.selectedClass)) {
				this.refreshTable();
			}
		},
		selectedClass() {
			this.refreshTable();
			store.set(this, "audit.r.selectedClass", this.selectedClass);
		},
		selectedState() {
			this.refreshTable();
			store.set(this, "audit.r.selectedState", this.selectedState);
		},
		selectedExportState() {
			this.refreshTable();
			store.set(this, "audit.r.exportState", this.selectedExportState);
		},
		selectedTeam() {
			store.set(this, "audit.r.selectedTeam", this.selectedTeam);
			this.refreshTable();
		},
		selectedCA() {
			if (this.selectedCA && this.selectedAsmt && this.selectedAsmt.content_area_id != this.selectedCA.id) {
				this.selectedAsmt = null;
			}

			store.set(this, "audit.r.selectedCA", this.selectedAsmt);
		},
		selectedGrade() {
			if (this.selectedGrade && this.selectedAsmt) {
				let found = false;
				_.each(this.selectedAsmt.grade_ids, (gid) => {
					if (this.selectedGrade.id == gid) {
						found = true;
					}
				});
				if (!found) {
					this.selectedAsmt = null;
				}
			}

			store.set(this, "audit.r.selectedGrade", this.selectedAsmt);
		},
		selectedAsmt() {
			this.refreshTable();
			store.set(this, "audit.r.selectedAsmt", this.selectedAsmt);
		},
		selectedItem(newVal, oldVal) {
			if (!this.selectedItem) {
				return;
			}

			this.audit_trait_scores = store.resolveAuditingTraitScores(this, this.selectedItem, "audit.r.trait_scores");
			this.setupTraitScoreSelections();
			if (!oldVal) {
				this.refreshTable();
			}
		},
		selectedFlagType() {
			this.refreshTable();
		},
		selectedFlagReviewType() {
			this.refreshTable();
		},
		response_id() {
			this.refreshTable();
			store.set(this, "audit.r.response_id", this.response_id);
		},
		student() {
			this.refreshTable();
			store.set(this, "audit.r.student", this.student);
		},
		users() {
			this.refreshTable();
			store.set(this, "audit.r.users", this.users);
		},
		archived() {
			this.refreshTable();
			store.set(this, "audit.r.archived", this.archived);
		},
		filter_types() {
			this.refreshTable();
			store.set(this, "audit.r.filter_types", this.filter_types);
		},
		score_specific_query() {
			this.audit_trait_scores = [];
			store.set(this, "audit.r.score_specific_query", this.score_specific_query);
		},
		audit_trait_scores() {
			store.set(this, "audit.r.trait_scores", this.audit_trait_scores);
			this.updateATSDisplay();
		},
		pickPriority() {
			if (this.pickPriority < 0) {
				this.pickPriority = 0;
			} else if (this.pickPriority > 100) {
				this.pickPriority = 100;
			}
		},
	},

	methods: {
		loadConfigData() {
			BB.props({
				contentAreas: ConfigService.listContentAreas(),
				grades: ConfigService.listGrades(),
				assessments: ConfigService.listAssessments(),
				teams: ConfigService.listTeams(),
			}).then((resps) => {
				this.contentAreas = resps.contentAreas.data.content_areas;
				this.selectedCA = store.resolveFromList(this, this.contentAreas, "id", null, "audit.r.selectedCA");

				this.grades = resps.grades.data;
				this.selectedGrade = store.resolveFromList(this, this.grades, "id", null, "audit.r.selectedGrade");

				this.assessments = resps.assessments.data.assessments;
				this.selectedAsmt = store.resolveFromList(this, this.assessments, "id", null, "audit.r.selectedAsmt");

				this.teams = resps.teams.data.teams;
				this.selectedTeam = store.resolveFromList(this, this.teams, "id", null, "audit.r.selectedTeam");

				this.loading = false;
				this.refreshTable();
			});
		},

		provider(ctx) {
			store.set(this, "audit.r.sortBy", this.sortBy);
			store.set(this, "audit.r.sortDesc", this.sortDesc);
			store.set(this, "audit.r.currentPage", this.currentPage);
			if (this.loading) {
				return [];
			}
			let query = this.getQuery();
			return BB.props({
				audit: AuditingService.auditQuery(query, ctx),
				item: ConfigService.getItem(this.selectedAsmt.id),
			})
				.then((resps) => {
					if (this.queueResetSelection) {
						this.resetSelection();
						this.queueResetSelection = false;
					}

					this.query = query;
					this.totalRows = resps.audit.data.totalRows;
					this.currentItems = resps.audit.data.rows;

					this.selectedItem = resps.item.data;

					this.resultArchived = this.archived;

					return this.currentItems;
				})
				.catch((err) => {
					return [];
				});
		},

		loadTeacherClasses() {
			if (this.teacher) {
				ClassService.getTeacherClasses(this.teacher.id).then((resp) => {
					this.teacherClasses = resp.data.classes;
				});
			} else {
				this.teacherClasses = [];
			}
			this.refreshTable();
		},

		getQuery() {
			let user_ids = [];
			_.each(this.users, (u) => {
				if (u.users) {
					_.each(u.users, (tu) => {
						user_ids.push(tu.id);
					});
				} else {
					user_ids.push(u.id);
				}
			});

			let query = {
				client_id: this.user && this.user.client.id,
				team_id: this.selectedTeam && this.selectedTeam.id,
				teacher_id: this.teacher && this.teacher.id,
				class_id: this.selectedClass && this.selectedClass.id,
				asmt_id: this.selectedAsmt && this.selectedAsmt.id,
				state: this.selectedState && this.selectedState.value,
				student_id: this.student && this.student.id,
				user_ids: user_ids,
				archived: this.archived,
				trait_scores: this.audit_trait_scores,
				score_types: _.map(this.filter_types, (t) => {
					return t.type;
				}),
			};

			return query;
		},

		getQueryAll() {
			let query = {
				client_id: this.user && this.user.client.id,
				asmt_id: this.selectedAsmt && this.selectedAsmt.id,
			};

			return query;
		},

		getState(state) {
			// console.log(state);
			var stateObj = _.find(this.states, { value: state });
			if (stateObj) {
				return stateObj.label;
			}
			return "?";
		},

		updateATSDisplay() {
			let rows = [];
			let scoreTypeNumMap = {};
			_.each(this.audit_trait_scores, (ats) => {
				var trait = _.find(this.selectedItem.rubric.traits, {
					id: ats.trait_id,
				});
				if (trait) {
					scoreTypeNumMap[ats.score_type] = scoreTypeNumMap[ats.score_type] || 0;
					scoreTypeNumMap[ats.score_type]++;
					rows.push({
						name: trait.name,
						score_type: ats.score_type,
						score: ats.score,
					});
				}
			});

			rows = _.orderBy(rows, ["score_type", "name"]);
			let currentScoreType = -1;
			_.each(rows, (row) => {
				if (currentScoreType != row.score_type) {
					row.first_of_type = true;
					row.rowspan = scoreTypeNumMap[row.score_type] || 1;
					currentScoreType = row.score_type;
				}
			});

			this.ats_display = rows;
		},

		format(date) {
			return moment(date).format("M/D/YY h:mm:ss a");
		},

		tsChange(trait_id, score_type) {
			return (r) => {
				this.traitSelectionMap[trait_id][score_type].selected = r;
				//Remove all entries for this trait_id and score_type
				_.remove(this.audit_trait_scores, (e) => {
					return e.trait_id == trait_id && e.score_type == score_type;
				});

				if (r) {
					this.audit_trait_scores.push({
						trait_id: trait_id,
						score_type: score_type,
						score: r.value,
					});
				}
			};
		},

		setupTraitScoreSelections() {
			//For each trait, and each score type, we need to create selection lists
			this.traitSelectionMap = null;
			var traitSelectionMap = {};
			var _this = this;
			_.each(this.selectedItem.rubric.traits, (t) => {
				var scoreTypeMap = {};
				var sps = [];
				for (var i = t.min; i < t.max + 1; i++) {
					sps.push({
						trait_id: t.id,
						label: "" + i,
						value: i,
					});
				}

				let selectedATS = _.find(this.audit_trait_scores, {
					trait_id: t.id,
					score_type: 0,
				});
				let selectedSP = selectedATS ? _.find(sps, { value: selectedATS.score }) : null;
				scoreTypeMap[0] = { selected: selectedSP, sps: sps };
				_.each(_this.score_types, (st) => {
					let selectedATS = _.find(this.audit_trait_scores, {
						trait_id: t.id,
						score_type: 0,
					});
					let selectedSP = selectedATS ? _.find(sps, { value: selectedATS.score }) : null;
					scoreTypeMap[st.type] = { selected: selectedSP, sps: sps };
				});

				_.each(scoreTypeMap, (st) => {
					_.each(st.sps, (sp) => {
						sp.st = st.type;
					});
				});

				traitSelectionMap[t.id] = scoreTypeMap;
			});
			this.traitSelectionMap = traitSelectionMap;
		},

		clearScoreSearch() {
			this.audit_trait_scores = [];
			this.score_specific_query = true;
			this.score_specific_query = false;
			this.traitSelectionMap = null;
			this.setupTraitScoreSelections();
			this.$forceUpdate();
			this.refreshTable();
		},

		queueExport() {
			let selection = {
				selected_ids: this.selectedIDs,
				select_all: this.selectAll,
				query: this.getQuery(),
			};
			AuditingService.queueExport(selection)
				.then((resp) => {
					Notie.success("Queued for API export");
					this.refreshAndResetSelection();
				})
				.catch((err) => {
					Notie.error("Failed to queue for API export", err);
				});
		},

		markReliability() {
			let selection = {
				selected_ids: this.selectedIDs,
				select_all: this.selectAll,
				query: this.getQuery(),
			};
			AuditingService.markReliability(selection)
				.then((resp) => {
					let success = resp.data.success;
					if (success > 0) {
						Notie.success(`Marked ${success} ${success > 1 ? "responses" : "response"} for reliability`);
					} else {
						Notie.info("All valid selected responses were already marked for reliability");
					}
					this.refreshAndResetSelection();
				})
				.catch((err) => {
					Notie.error("Failed to mark responses for reliability", err);
				});
		},

		setPriority(priority) {
			let selection = {
				selected_ids: this.selectedIDs,
				select_all: this.selectAll,
				query: this.getQuery(),
			};
			AuditingService.setResponsePriority(selection, priority)
				.then((resp) => {
					Notie.success("Priorities set");
					this.pickPriority = 0;
					this.refreshAndResetSelection();
				})
				.catch((err) => {
					Notie.error("Failed to set priorities", err);
				});
		},

		deleteResponses() {
			let selection = {
				selected_ids: this.selectedIDs,
				select_all: this.selectAll,
				query: this.getQuery(),
			};
			AuditingService.deleteResponses(selection)
				.then((resp) => {
					Notie.success("Responses deleted!");
					this.refreshAndResetSelection();
				})
				.catch((err) => {
					Notie.error("Failed to delete responses", err);
				});
		},

		resetResponses() {
			let selection = {
				selected_ids: this.selectedIDs,
				select_all: this.selectAll,
				query: this.getQuery(),
			};
			AuditingService.resetResponses(selection)
				.then((resp) => {
					Notie.success("Scores cleared from responses!");
					this.refreshAndResetSelection();
				})
				.catch((err) => {
					Notie.error("Failed to clear scores from responses", err);
				});
		},

		//Scoring stuff
		canScore(resp) {
			return ScoringService.canScore(resp);
		},

		score(resp) {
			this.selected_resp = resp;
			var scr = _.find(resp.scores, { user_id: this.user.id });
			if (scr) {
				this.showAlreadyScoredModal(resp);
				return;
			}
			this.scoreResponse(resp);
		},

		scoreResponse(resp) {
			ScoringService.auditScore(resp, this.$router).catch((err) => {
				console.log(err);
				Notie.error("Could not enter scoring", err);
			});
		},

		showAlreadyScoredModal(resp) {
			$("#alreadyScoredWarning").modal("show");
		},

		unlock(resp) {
			ScoringService.unlockResponse(resp)
				.then(() => {
					Notie.info("Response unlocked");
					this.refreshTable();
				})
				.catch((e) => {
					Notie.error("Failed to unlock response");
					this.refreshTable();
				});
		},

		resetSelection() {
			this.selectedIDs = [];
			this.selectAll = false;
		},

		refreshAndResetSelection() {
			this.queueResetSelection = true;
			this.refreshTable();
		},

		showQueryModal() {
			this.oldScoreQuery = _.cloneDeep(this.audit_trait_scores);
			this.applyATS = false;
			this.updateTraitScoreMap();
			this.queryModal = true;
		},

		updateTraitScoreMap() {
			_.each(this.traitSelectionMap, (trait) => {
				_.each(trait, (opt) => {
					opt.selected = null;
				});
			});

			_.each(this.audit_trait_scores, (ats) => {
				let trait = this.traitSelectionMap[ats.trait_id];
				if (trait) {
					let opt = trait[ats.score_type];
					if (opt) {
						let choice = _.find(opt.sps, { value: ats.score });
						if (choice) {
							opt.selected = choice;
						}
					}
				}
			});

			this.$forceUpdate();
		},

		hideQueryModal() {
			if (!this.applyATS) {
				this.audit_trait_scores = _.cloneDeep(this.oldScoreQuery);
			} else {
				this.applyATS = false;
			}
		},

		applyQueryModal() {
			this.applyATS = true;
			this.queryModal = false;
			this.refreshTable();
		},

		allFlagsReviewed(response) {
			let allReviewed = true;
			_.each(response.flags, (flag) => {
				if (!flag.reviewed) {
					allReviewed = false;
				}
			});

			return allReviewed;
		},

		auditDetailsTooltip(row) {
			if (row.student_fn || row.student_ln) {
				let tooltip = `
				<table class="my-2">
					<tr>
						<td class="px-2 py-1 _600">${row.teacher_names && row.teacher_names.length == 1 ? "Teacher" : "Teachers"}:</td>
						<td class="px-2 py-1">${row.teacher_names ? row.teacher_names.join(", ") : '<span class="text-muted">(N/A)</span>'}</td>
					</tr>
					<tr class="b-t">
						<td class="px-2 py-1 _600">Class:</td>
						<td class="px-2 py-1">${row.class_name || '<span class="text-muted">(N/A)</span>'}</td>
					</tr>
					<tr class="b-t">
						<td class="px-2 py-1 _600">Administration:</td>
						<td class="px-2 py-1">${row.delivery_name || '<span class="text-muted">(N/A)</span>'}</div>
					</tr>
				</table>
				`;

				return tooltip;
			} else {
				let tooltip = `
				<div class="my-2">
					The student attached to this response can no longer be found
				</div>
				<div class="mb-2 text-muted text-xxs">ID: ${row.id}
				`;

				return tooltip;
			}
		},

		attemptExport(item) {
			this.exportingItem = this.selectedItem;
		},

		stopExport() {
			this.exportingItem = false;
			this.exportType = null;
		},

		exportScores(asmt, item, type) {
			window.location = `/v1/export/scores?asmt_id=${asmt.id}&item_id=${item.id}&type=${type.id}`;
		},

		getTeam(teamID) {
			if (!(this.teams && this.teams.length > 0)) {
				return null;
			}

			return _.find(this.teams, { id: teamID });
		},

		cstTooltip(teamName) {
			return `<div class="text-left"><div class="text-xxs text-muted">Collaborative Scoring Team</div><div>${teamName}</div></div>`;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/vues/QualityMgmt/Auditing.vue